import { render } from "./singleUserDetail.vue?vue&type=template&id=3ae399d0&scoped=true"
import script from "./singleUserDetail.vue?vue&type=script&lang=js"
export * from "./singleUserDetail.vue?vue&type=script&lang=js"

import "./singleUserDetail.vue?vue&type=style&index=0&id=3ae399d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae399d0"]])

export default __exports__